<template>
    <div v-if="screen_data.document">
        <div>
            <v-toolbar class="toolbar sticky-toolbar">
                <div>
                    <v-tooltip bottom v-if="show_prev">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                color="primary"
                                @click="goToPrev()"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon >mdi-arrow-left</v-icon>
                            </v-btn>
                        </template>
                        <span>Ir al anterior</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="show_next" >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                color="primary"
                                @click="goToNext()"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon >mdi-arrow-right</v-icon>
                            </v-btn>
                        </template>
                        <span>Ir al siguiente</span>
                    </v-tooltip>
                </div>
                <div v-if="show_approve_reject">
                    <v-btn 
                        color="white" 
                        text 
                        class="primary-background ml-2 rounded-xl"
                        @click="approve()"
                        :loading="screen_data.loadingApprove"
                        :disabled="screen_data.dirty"
                        >Aprobar
                    </v-btn>
                    <v-btn 
                        color="primary" 
                        outlined 
                        text 
                        class="primary-border ml-2 rounded-xl"
                        @click="reject()"
                        :loading="screen_data.loadingRejected"
                        :disabled="screen_data.dirty"
                        >Rechazar
                    </v-btn>
                </div>
                <v-spacer></v-spacer>
                
                <div v-if="!screen_data.loadingContinueFlow">
                    {{ $t("GeneralWorkflowDetail.state") }}: <b>
                        {{$t("ViesValidator."+screen_data.document.state)}}</b>
                </div>
                <div v-else>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        size="20"
                        width="2"
                    />
                </div>
                
                <v-spacer></v-spacer>
                <v-btn
                    class="mt-1 mr-1"
                    color="primary"
                    @click="$emit('global_save')"
                    :loading="loading_save" 
                    outlined
                    fab
                    small
                >
                    <v-icon v-once>mdi-content-save</v-icon>
                </v-btn>
                <div v-if="!show_approve_reject">
                    <v-btn
                        variant="text"
                        color="white"
                        class="primary-background rounded-xl"
                        outlined
                        :disabled="!canContinueWorkflow"
                        @click="continueWorkflow"
                        :loading="screen_data.loadingContinueFlow || screen_data.document.state == 'pending'"
                    >
                    <template #loader>
                        <v-progress-circular
                          indeterminate
                          color="white"
                          size="20"
                          width="2"
                        />
                      </template>
                        {{ $t('GeneralWorkflowDetail.continue_workflow') }}
                    </v-btn>
                </div>

                <v-menu
                    v-model="screen_data.action_menu"
                    :close-on-click="true"
                    :close-on-content-click="true"
                    offset-y
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        class="action-btn-doc ml-1"
                        color="primary"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        :disabled="Boolean(permission.is_readonly)"
                        >
                        <v-icon v-once>mdi-menu</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item-group color="primary">
                        <v-list-item
                            link
                            @click="retryWorkflow"
                            class="list"
                        >
                            <v-list-item-title class="list-title">
                            {{ $t("ViesValidator.restart_workflow") }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            link
                            @click="download"
                            class="list"
                        >
                            <v-list-item-title class="list-title">
                            {{ $t("ViesValidator.download") }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            link
                            @click="moveToFolder"
                            class="list"
                        >
                            <v-list-item-title class="list-title">
                            {{ $t("ViesValidator.move_to_a_folder") }}
                            </v-list-item-title>
                        </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-menu>
            </v-toolbar>
        </div>
        <div class="content">
            <v-container>
                <div v-if="(screen_data.allStages.length > 0)">
                    <!-- <p>---{{ screen_data.currentStage }}</p>
                    <p>---{{ screen_data.allStages }}</p>
                    <p>---{{ screen_data.allStages.length }}</p>
                    <p>---{{ stepper_step }}</p> -->
                    

                    <v-stepper
                        :value="stepper_step"
                        vertical
                        class="stepper"
                        >
                        
                        <div v-for="(step, index) in screen_data.allStages" :key="index.toString() + step.name">
                            <v-stepper-step
                                v-if="step.visible || staff_or_loginas"
                                :step="staff_or_loginas?index +1:index_of_visible(index +1)"
                                :complete="stepper_step > (staff_or_loginas ? index + 1 : index_of_visible(index + 1))"
                                :color="stepper_step >= (staff_or_loginas ? index + 1 : index_of_visible(index + 1)) ? 'primary' : 'grey'"
                                :rules="[() => !(stepper_step === (staff_or_loginas ? index + 1 : index_of_visible(index + 1)) && ['error'].includes(screen_data.document.state))]"
                            >
                                <div v-if="step.name === 'WaitForApproval'">
                                    {{ step.nickname? step.nickname : $t("ViesValidator."+step.name) }} <b>{{ step.username }}</b> 
                                    <span v-if="screen_data.document.rejecters && screen_data.document.rejecters.includes(step.username)">
                                    <small> (Rechazado)</small>
                                    </span>
                                    <span v-if="(staff_or_loginas ? index + 1 : index_of_visible(index + 1)) < stepper_step && screen_data.document.approvers && screen_data.document.approvers.includes(step.username)">
                                    <small> (Aprobado) </small>
                                    </span>
                                </div>
                                <div v-else-if="step.name === 'AskAI'"> 
                                    {{ step.nickname? step.nickname : $t("ViesValidator."+step.name) }} <b>{{ step.key }}</b> 
                                </div>
                                <div v-else>
                                    {{ step.nickname? step.nickname : $t("ViesValidator."+step.name) }}
                                </div>
                            </v-stepper-step>
                    
                            <!-- Add a divider between steps except for the last one -->
                            <v-divider v-if="index + 1 < screen_data.allStages.length"></v-divider>
                        </div>
                    </v-stepper>
                </div>

            </v-container>
            <div v-if="!screen_data.loadingContinueFlow && screen_data.document.state != 'pending'" style="background-color: #F5F5F5; border-radius: 8px; margin: 8px 0; padding: 4px 0;">
                <slot name="custom-content"></slot>
            </div>
                <div style="width: 100%;display: flex;justify-content: center;" v-else>
                    <v-progress-circular
                        class="pa-8"
                        indeterminate
                        color="primary"
                        size="20"
                        width="2"
                    />
                </div>
            <v-container class="mt-2 mb-1" v-if="screen_data.document.comments">
                <!-- <v-tooltip bottom >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            color="primary"
                            @click="saveComments()"
                            :loading="screen_data.loadingSave"
                            :disabled="comments_dirty == false"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon v-once>mdi-content-save</v-icon>
                        </v-btn>
                    </template>
                    <span>Guardar comentarios</span>
                </v-tooltip> -->
                <CommentSectionComponent
                    v-model="screen_data.document.comments"
                    :userName="userData.username"
                    @new-comment="comments_dirty = true"
                    ></CommentSectionComponent>
            </v-container>
            <v-divider></v-divider>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import DocTextField from '@/components/DocTextField.vue';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import CommentSectionComponent from '@/modules/document/infra/CommentSectionComponent'
import JobProgress from "@/components/JobProgress.vue";
import ViesValidator from "@/components/ViesValidator.vue";
export default {
    name: "GeneralWorkflowDetail",
    components: {
        DocTextField,
        CommentSectionComponent
    },
    data() {
        return {
            comments_dirty: false,
        }
    },
    props: {
        screen_data:{
            type: [Object],
            required: true,
            default: null
        },
        staff_or_loginas:{
            type: [Boolean],
            required: true,
            default: false
        },
        show_next: {
            type: [Boolean],
            required: false,
            default: false
        },
        show_prev: {
            type: [Boolean],
            required: false,
            default: false
        },
        loading_save:{
            type: [Boolean],
            required: false,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            me: "me/me",
            userData: "me/userData",
            permission: 'permissions/permission',
        }),
        canContinueWorkflow() {
            return  this.screen_data.allStages && this.screen_data.allStages.length > 0 && this.permission.can_write &&
                    ([undefined, null].includes(this.screen_data.currentStage) ||
                     !(this.screen_data.allStages[this.screen_data.currentStage]['name'] == 'WaitForApproval' && this.screen_data.document.state != 'error'))
        },
        current_stage() {
            if (this.screen_data.currentStage != undefined) {
                if (['pending', 'waiting_approval', 'rejected', 'insufficient_credits', 'waiting'].includes(this.screen_data.document.state))
                    return this.screen_data.currentStage + 1
                else
                    return this.screen_data.currentStage + 2
            } else {
                return this.screen_data.allStages.length + 1
            }
        },
        stepper_step() {
            if ([null, undefined].includes(this.screen_data.currentStage)) {
                return this.screen_data.allStages.length +1
            }
            if (this.staff_or_loginas) {
                // Staff view: use raw index
                return this.screen_data.currentStage + 1
            } else {
                // Client view: calculate visible step number
                return this.index_of_visible(this.screen_data.currentStage + 1)
            }
        },
        show_approve_reject(){
            return (this.screen_data.allStages.length > 0 && this.screen_data.currentStage != undefined && this.screen_data.allStages[this.screen_data.currentStage]['name'] == 'WaitForApproval' &&
                    this.screen_data.allStages[this.screen_data.currentStage]['username'] == this.userData.username && !['rejected', 'approved'].includes(this.screen_data.document.state))
        }
    },
    methods: {
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        approve(){
            this.$emit('approve')
        },
        reject(){
            this.$emit('reject')
        },
        saveComments(){
            this.comments_dirty = false
            this.$emit('save-comments')
        },
        continueWorkflow(){
            this.$emit('continueWorkflow')
        },
        retryWorkflow(){
            this.$emit('retryWorkflow')
        },
        setDirty(value) {
            this.screen_data.setDirty(value)
        },
        goToNext(){ 
            this.$emit('next')
        },
        goToPrev(){
            this.$emit('prev')
        },
        index_of_visible(index){
            let invisibles = 0
            for (let i = 0; i < index; i++) {
                if (!this.screen_data.allStages[i].visible) {
                    invisibles += 1
                }
            }
            return index - invisibles
        },
        download(){
            this.$emit('download')
        },
        moveToFolder(){
            this.$emit('moveToFolder')
        }

    },
    // mounted() {
        
    // }
    
};
</script>

<style scoped>
.primary-background {
    background-color: var(--v-primary-base);
    text-transform: capitalize;
}
.primary-border {
    border-color: var(--v-primary-base) !important;
    text-transform: capitalize;
}
</style>
<style>
/* .toolbar > .v-toolbar__content {
    justify-content: space-around;
} */

.stepper.v-stepper--vertical {
    padding: 0px ;
} 

.stepper.v-stepper {
    box-shadow: none;
}

.v-progress-circular {
    text-align:center;
    /* width: -20px; */

    
}

.action__btn {
    border: 1px solid var(--v-primary-base) ;
    border-radius: 18px;
    color: var(--v-primary-base);
    background-color: #FFFFFF !important;
}
.sticky-toolbar {
  position: sticky;
  top: 0;
  z-index: 10;          /* Ensure it stays above other content */
}
.content {
  height: 83vh;  
  overflow-y:auto;
  overflow-x: hidden;
}
</style>